import { usePlanMainTarget } from "@/components/features/items/edit/plan/_shared/ui/components/main-target/hooks";

import { useProductDayTripPlanI18nFormModelContext } from "../../../../_context";

export const useDayTripPlanI18nMainTarget = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanI18nFormModelContext();
	const { mainTarget } = viewModel;

	return usePlanMainTarget({ mainTarget, onSetViewModel });
};
